import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Vendors = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Vendors;
